export class FoodLogProgress {
    public  NutritiononId:number; 
    public  NutritionName:string; 
    public NutritionDoneSoFar:number; 
    public NutritionTotalLimit:number;
    public NutritionCompletePercentage:string;
    public NutritionActualPercentage:number;
    public MealTotal:number;
}
